import React, { useEffect, useState } from "react"
import CRMService from "src/services/CRMService"
import PopupAction from "src/components/PopupAction"
import { PaginationStyle } from "../../../HumanResource/styled"
import IconBase from "src/components/IconBase"
import dayjs from "dayjs"
import CustomModal from "src/components/Modal/CustomModal"
import ToolBarCustomLayer from "src/components/ToolBarCustom/ToolBarCustomLayer"
import notice from "src/components/Notice"
import { Empty, InputNumber, message, Table } from "antd"
import SettingPriceService from "src/services/SettingPriceService"
import { TableCustomStyled } from "../../styled"
import ModalUpdatePrice from "./ModalUpdatePrice"
import Button from "src/components/MyButton/Button"
import STORAGE, { getStorage } from "src/lib/storage"

function ListPrice({ refresh, setRefresh, setSummary, ...props }) {
  console.log(props, "props")
  const [listPriceConfig, setListPriceConfig] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [perPage, setPerPage] = useState(10)
  const [total, setTotal] = useState(0)
  const [isModalIDDetail, setIsModalIDDetail] = useState()
  const [isModalIDUpdate, setIsModalIDUpdate] = useState()
  const [type, setType] = useState("common")
  const [editingRow, setEditingRow] = useState(null) // ID của row đang sửa
  const [editingData, setEditingData] = useState({}) // Dữ liệu đang sửa
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const getPriceConfig = () => {
    setLoading(true)
    const params = {
      page: currentPage,
      per_page: perPage,
      // type
    }
    SettingPriceService.getListPrice(params)
      .then(res => {
        const { success } = res
        console.log("success", success)
        setListPriceConfig(success?.data || [])
        setTotal(success.total)
        setSummary(success.total)
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    getPriceConfig()
  }, [currentPage, perPage, refresh])

  const handleUpdateList = async id => {
    // setLoading(true)
    try {
      await SettingPriceService.updateList(id)
      message.success("Cập nhật danh sách thành công")
    } catch (error) {
      console.error(error)
      message.error("Cập nhật danh sách thất bại")
    } finally {
      // setLoading(false)
      setRefresh(!refresh)
    }
  }

  const columns = [
    Table.EXPAND_COLUMN,
    {
      title: "Ngày áp dụng",
      dataIndex: "start_time",
      key: "start_time",
      render: value => <span>{dayjs(value).format("DD/MM/YYYY")}</span>,
      width: 110,
      align: "center",
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      align: "center",
    },
  ]
  if (permissions.includes("setting.update")) {
    columns.push({
      title: "Hành động",
      dataIndex: "action",
      key: "action",
      align: "center",
      onHeaderCell: () => ({
        style: { minWidth: 30 },
      }),
      onCell: () => ({
        onClick: event => event.stopPropagation(),
      }),
      render: (_, record) => {
        console.log("record", record)
        const apply_date = record.start_time
        return (
          <PopupAction>
            <div
              onClick={() => {
                // if (new Date() > new Date(apply_date)) {
                //   notice({
                //     msg: "Không thể cập nhật giá bán đã áp dụng",
                //     isSuccess: false,
                //   })
                //   return
                // }
                setIsModalIDUpdate(record.ID)
              }}
            >
              <IconBase name="edit" />
              <span>Sửa giá bán</span>
            </div>
            <div
              onClick={() => {
                // if (new Date() > new Date(apply_date)) {
                //   notice({
                //     msg: "Không thể cập nhật giá bán đã áp dụng",
                //     isSuccess: false,
                //   })
                //   return
                // }
                handleUpdateList(record.ID)
              }}
            >
              <IconBase name="refresh" />
              <span>Cập nhật</span>
            </div>
          </PopupAction>
        )
      },
    })
  }

  const itemsLeft = [
    // {
    //     key: "drop_down",
    //     component: (
    //         // <SelectStyle
    //         //     defaultValue={type}
    //         //     onChange={(value) => {
    //         //         setType(value)
    //         //     }}
    //         //     style={{ maxWidth: '200px', width: '150px', height: '37px' }}
    //         //     options={TYPE.map(item => ({ value: item.value, label: item.name }))}
    //         // />
    //     )
    // },
  ]

  const expandedRowRender = record => {
    const parseData = (data, type) =>
      (data || []).map((item, index) => ({
        ...item,
        price: Number(item.price).toLocaleString("en-US"),
      }))
    let dataPrice = null
    if (permissions.includes("setting.detail")) {
      dataPrice = parseData(record.settings)
    }

    const createColumns = permissions.includes("setting.detail")
      ? [
          {
            title: "Nhà mạng",
            dataIndex: "network",
            key: "network",
            align: "center",
            render: value => value?.name || "-",
          },
          {
            title: "Local/Roaming",
            align: "center",
            dataIndex: "scope",
            key: "scope",
            render: value => {
              if (value === "1") return "Local"
              if (value === "2") return "Roaming"
              return value
            },
          },
          {
            title: "Loại SIM",
            dataIndex: "type_sim",
            align: "center",
            render: value => {
              if (value === "esim") return "E-SIM"
              if (value === "usim") return "Sim vật lý"
              return value
            },
          },
          {
            title: "Loại hình SIM",
            dataIndex: "sim_type",
            align: "center",
            render: value => {
              if (value === "2") return "Travel"
              if (value === "1") return "IoT"
              return value
            },
          },
          {
            title: "Giá bán",
            dataIndex: "price",
            key: "price",
            align: "right",
            onHeaderCell: () => ({
              style: { textAlign: "center" },
            }),
            render: (value, row, index) => {
              const isEditing = editingRow === row.ID // mỗi item nên có ID riêng
              return isEditing ? (
                <InputNumber
                  style={{ width: 100 }}
                  min={0}
                  value={editingData[row.ID]?.price || ""}
                  onChange={e => {
                    const updated = {
                      ...editingData,
                      [row.ID]: {
                        ...row,
                        price: value,
                      },
                    }
                    setEditingData(updated)
                  }}
                />
              ) : (
                value
              )
            },
          },
          // {
          //   title: "Hành động",
          //   dataIndex: "actions",
          //   withd: 50,
          //   key: "actions",
          //   align: "center",
          //   render: (_, row) => {
          //     const isEditing = editingRow === row.ID
          //     return isEditing ? (
          //       <div style={{ display: "flex", justifyContent: "center" }}>
          //         <Button
          //           onClick={() => handleSave(row.ID)}
          //           style={{ marginRight: 8 }}
          //           btnType="primary1"
          //         >
          //           Lưu
          //         </Button>
          //         <Button onClick={() => cancelEdit()}>Huỷ</Button>
          //       </div>
          //     ) : (
          //       <div style={{ display: "flex", justifyContent: "center" }}>
          //         <Button onClick={() => startEdit(row)}>Sửa</Button>
          //       </div>
          //     )
          //   },
          // },
        ]
      : []

    const startEdit = row => {
      setEditingRow(row.ID)
      setEditingData(prev => ({
        ...prev,
        [row.ID]: row,
      }))
    }

    const cancelEdit = () => {
      setEditingRow(null)
    }

    const handleSave = id => {
      const data = editingData[id]

      console.log(data, "data")
      if (!data) return
      console.log(id, "id")
      console.log(data, "data")

      // Gọi API update
      SettingPriceService.updatePrice(data)
        .then(res => {
          notice({ msg: "Cập nhật thành công", isSuccess: true })
          setEditingRow(null)
          getPriceConfig() // refresh list
        })
        .catch(() => {
          notice({ msg: "Có lỗi xảy ra", isSuccess: false })
        })
    }

    // const columnsFull = createColumns("Full time")
    // const columnsPart = createColumns("Part time");

    const renderTable = (columns, dataSource) => (
      <TableCustomStyled noMrb={false} isPrimary={false} showPagination={false}>
        <Table columns={columns} dataSource={dataSource} pagination={false} />
      </TableCustomStyled>
    )

    return (
      <>
        {renderTable(createColumns, dataPrice)}
        {/* {renderTable(columnsPart, dataPartTime)} */}
      </>
    )
  }

  return (
    <div>
      <ToolBarCustomLayer itemsLeft={itemsLeft} />
      <TableCustomStyled noMrb={true} isPrimary={true}>
        <Table
          columns={columns}
          dataSource={listPriceConfig}
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: perPage,
            total: total,
          }}
          onRow={record => ({
            onClick: event => {
              if (
                !event.target.closest(".ant-checkbox-wrapper") && // Không phải checkbox
                !event.target.closest("td.ant-table-selection-column") // Không phải cột select
              ) {
                setIsModalIDDetail(record.ID)
              }
            },
          })}
          expandable={{
            expandedRowRender,
          }}
          rowKey={record => record.ID}
          footerLeft={<div className="d-flex mt-20" />}
          widthScroll={1200}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Không có dữ liệu!"
              />
            ),
          }}
          scroll={listPriceConfig ? { x: "100%" } : {}}
        />
      </TableCustomStyled>
      <PaginationStyle
        pageSizeOptions={["10", "20", "50", "100"]}
        current={currentPage}
        pageSize={perPage}
        defaultPageSize={10}
        showSizeChanger
        onShowSizeChange={(page, pageSize) => {
          setPerPage(pageSize)
          setCurrentPage(page)
        }}
        onChange={(page, pageSize) => {
          setCurrentPage(page)
          setPerPage(pageSize)
        }}
        defaultCurrent={1}
        total={total}
        itemRender={(page, type, originalElement) => {
          if (type === "page") {
            return (
              <span
                style={{
                  fontWeight: page === currentPage ? "bold" : "normal",
                  color: page === currentPage ? "#1890ff" : "inherit", // Hiển thị màu khi trang hiện tại đang active
                }}
              >
                {page}
              </span>
            )
          }
          return originalElement
        }}
      />
      {/* {isModalIDDetail && (
        <CustomModal
          title={"Chi tiết giá bán"}
          open={isModalIDDetail}
          onCancel={() => setIsModalIDDetail(null)}
          footer={null}
          size="large"
        >
          <SalaryConfigDetail
            salaryConfigId={isModalIDDetail}
            onCancel={() => setIsModalIDDetail(null)}
          />
        </CustomModal>
      )} */}
      {isModalIDUpdate && (
        <CustomModal
          title={"Cập nhật giá bán"}
          open={isModalIDUpdate}
          onCancel={() => setIsModalIDUpdate(null)}
          footer={null}
          size="large"
        >
          <ModalUpdatePrice
            priceConfigId={isModalIDUpdate}
            onCancel={() => setIsModalIDUpdate(null)}
            getListPriceConfig={getPriceConfig}
          />
        </CustomModal>
      )}
    </div>
  )
}

export default ListPrice
